// extracted by mini-css-extract-plugin
export default {"ContactsList":"ContactsList_ContactsList__vMNnS","Icon":"ContactsList_Icon__8O+h5","Text":"ContactsList_Text__rA2Ro"};